import { ReactNode } from 'react';
import { LoadingIndicator, Widget } from '@asset-metrix/portal-ui';

import styles from './fullscreenframe.module.scss';

type FrameProps = {
  children: ReactNode;
  loading?: boolean;
  title?: string;
};

export const FullScreenFrame = ({ title, loading, children }: FrameProps) => {
  return (
    <div className={styles['root']}>
      <div className={styles['tenant-logo']} />
      <div className={styles['frame']}>
        <Widget
          title={title ?? ''}
          style={{ minHeight: loading ? '9em' : 'auto' }}
        >
          {children}
          {loading && (
            <LoadingIndicator
              style={{
                position: 'absolute',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                left: '50%',
                fontSize: '2.5em',
              }}
            />
          )}
        </Widget>
      </div>
    </div>
  );
};
